module.exports = __webpack_public_path__ + "img/ocean-hotel.77be02e9.jpg";